import Commands from './commands';

class Set extends Commands {
    constructor(registry) {
        super("set", registry);
    }

    async execute(node, emitter, options) {
        const key = await emitter(node.params[0], options);
        const value = await emitter(node.params[1], options);
        return this.registry.set(key, value);
    }
}

export default Set;
